// Promo timestamps cross the API as UTC LocalDateTime; administration uses Kyiv time.
const formatter = new Intl.DateTimeFormat('sv-SE', {
  timeZone: 'Europe/Kyiv', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
});
const utcDate = value => new Date(/[Zz]$|[+-]\d\d:\d\d$/.test(value) ? value : `${value}Z`);
export const promoDateInput = value => value ? formatter.format(utcDate(value)).replace(' ', 'T') : '';
export const promoDateLabel = value => value ? utcDate(value).toLocaleString('uk-UA', {
  timeZone: 'Europe/Kyiv', dateStyle: 'short', timeStyle: 'short',
}) : 'Без обмеження';
export const promoDateToUtc = value => {
  if (!value) return null;
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) throw new Error('Некоректна дата');
  const desired = Date.parse(`${value}Z`);
  let instant = desired;
  for (let i = 0; i < 4; i += 1) {
    const local = formatter.format(new Date(instant)).replace(' ', 'T');
    if (local === value) return new Date(instant).toISOString().replace(/Z$/, '');
    instant += desired - Date.parse(`${local}Z`);
  }
  throw new Error('Цього часу немає в Києві через перехід на літній час. Оберіть інший час.');
};
